module.exports = __webpack_public_path__ + "img/frame07_normal.42d0f980.png";